import { render } from "./arrow_down_circle.svg.vue?vue&type=template&id=14125bd4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__